<template>
  <v-container style="height: 80vh; overflow-y: auto; overflow-x: hidden;">
    <v-data-table
      :headers="headers"
      :items="claim_items"
      class=""
      :loading="claimsLoading"
      hide-default-footer
      hide-default-header
      :items-per-page="-1"
      loading-text="Загружаю данные"
      item-key="DOC_NUM"
      @click:row="onRowClick"
      fixed-header
      height="100%"
    >
      <template v-slot:top>
      </template>
      <template v-slot:no-data>
        Нет запросов данного типа в данном статусе
      </template>
      <template v-slot:[`item.DOC_ITEM`]="{ item }">
        <claimCard :claim="item" :mode="'simple'" :highlight="highlight ? isSelected(item) : false" />
      </template>
    </v-data-table>
  </v-container>
</template>

<script>

import { CLM_SET_CURRENT_CLAIM } from '@/store/actions/claims'

export default {
  name: 'claimsList',
  props: ['highlight'],
  components: {
    claimCard: () => import(/* webpackChunkName: "claimsModule" */ '@/components/modules/claims/cards/claimCard.vue')
  },
  data () {
    return {
      headers: [
        { text: 'Запросы', align: 'start', sortable: true, cellClass: 'pl-0 pr-0', value: 'DOC_ITEM' }
      ]
    }
  },
  computed: {
    claimsLoading: {
      get: function () {
        return this.$store.getters.getClaimListLoading
      }
    },
    claim_items: {
      get: function () {
        return this.$store.getters.getCurrentClaimsList
      }
    },
    selectedClaim: {
      get: function () {
        return this.$store.getters.getCurrentClaim
      },
      set: function (val) {
        this.$store.dispatch(CLM_SET_CURRENT_CLAIM, val)
        this.$emit('input', val)
      }
    }
  },
  watch: {
  },
  methods: {
    onRowClick (item) {
      console.log('claimsList: onRowClick called', item)
      if (item !== this.selectedClaim) {
        this.selectedClaim = item
      }
    },
    isSelected (item) {
      return item === this.selectedClaim
    }
  }

}
</script>
